module.exports = __webpack_public_path__ + "img/rosemount-648-wireless-temperature-transmitter-1-front.af705341.png";